import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { DateTime } from 'luxon';
import { StatisticEventDTO } from 'src/app/base/models/models.swagger.generated';

@Component({
  selector: 'app-statistic-event-detail-dialog',
  templateUrl: './statistic-event-detail-dialog.component.html',
  styleUrls: ['./statistic-event-detail-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DialogModule, TranslatePipe],
})
export class StatisticEventDetailDialogComponent {

  @Input() event: StatisticEventDTO | null = null;
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  public close(): void {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  public formatDateTime(dt: DateTime | undefined): string {
    return dt ? dt.toFormat('dd.MM.yyyy HH:mm') : '—';
  }

  public formatTripId(tripId: number | undefined): string {
    return tripId == null ? '—' : tripId.toString();
  }

  public formatSeverity(value: number | undefined): string {
    return value == null ? '—' : value.toString();
  }

  public formattedValueJson(json: string | undefined): string {
    if (!json) {
      return '—';
    }
    try {
      return JSON.stringify(JSON.parse(json), null, 2);
    } catch {
      return json;
    }
  }
}
